export class MediaImagePlaylist {

    // staff
    imagePlaylist = $('.structure--image-playlist');

    constructor() {
        this.init();
    }

    init() {
        if (this.imagePlaylist.length) {
            this.startPlaylist();
        }
    }

    startPlaylist() {
        this.imagePlaylist.each((key, imageList) => {
            const imageModule = $(imageList);
            if (!imageModule.length) {
                return;
            }

            // Imagen principal
            const mainImage = imageModule.find('.image-playlist-main-image');
            if (!mainImage.length) {
                return;
            }

            const mainCardNews = $(mainImage[0]).find('.card-news--image-playlist');
            if (!mainCardNews.length) {
                return;
            }

            // Playlist de imágenes
            const playlist = imageModule.find('.image-playlist-scrollbox');
            if (!playlist.length) {
                return;
            }

            const cardNews = $(playlist[0]).find('.card-news--image-playlist');
            if (!cardNews.length) {
                return;
            }

            cardNews.each((key, item) => {
                const cardNewsItem = $(item);

                // Cambiamos la imagen principal
                cardNewsItem.click((e) => {
                    e.preventDefault();

                    mainCardNews.empty();
                    mainCardNews.html(cardNewsItem.clone());
                });
            });
        });
    }
}
